import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
type ReadOnlyBranchDisplayProps = {
  branchNameLabel: string;
  branchName: string;
  rules: Array<string>;
  itemsLabel: string;
};
export const ReadOnlyBranchDisplay = t0 => {
  const $ = _c(17);
  const {
    branchNameLabel,
    branchName,
    rules,
    itemsLabel
  } = t0;
  let t1;
  if ($[0] !== branchNameLabel) {
    t1 = <span className="text-tertiary">{branchNameLabel}</span>;
    $[0] = branchNameLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== branchName) {
    t2 = <span className="max-md:truncate">{branchName}</span>;
    $[2] = branchName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <header className="flex items-center justify-between gap-1 bg-secondary h-[48px] py-2 px-4 relative border-b border-tertiary"><div className="flex flex-row justify-between gap-1 w-full max-md:min-w-0"><div className="text-label-2 text-primary flex items-center gap-2 w-full whitespace-nowrap max-md:min-w-0">{t1}{t2}</div></div></header>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== itemsLabel) {
    t4 = <div className="text-label-2 text-primary">{itemsLabel}</div>;
    $[7] = itemsLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rules) {
    t5 = rules.map(_temp);
    $[9] = rules;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex flex-col p-4 gap-3">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <section className="border overflow-hidden border-tertiary border rounded">{t3}{t6}</section>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
const ReadOnlyRule = t0 => {
  const $ = _c(10);
  const {
    rule,
    ruleIndex
  } = t0;
  const {
    t
  } = useTranslation("playbook-builder");
  let t1;
  if ($[0] !== ruleIndex || $[1] !== t) {
    t1 = ruleIndex === 0 ? t(_temp2) : t(_temp3);
    $[0] = ruleIndex;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center justify-center border-r border-tertiary px-1.5 min-w-[30px] bg-secondary rounded-l"><p className="flex-shrink-0 text-center text-caption-1 text-tertiary">{t1}</p></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== rule) {
    t3 = <div className="flex items-center flex-1 min-w-0 gap-2 px-3 py-1"><div className="min-h-[24px] content-center"><div className="text-snippet-2">{rule}</div></div></div>;
    $[5] = rule;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <li className="flex flex-col w-full"><div className="grid grid-cols-[1fr_auto] gap-2 items-center justify-items-start max-w-full"><div className="flex-1 rounded relative w-full min-w-0 border border-primary border-box"><div className="flex items-stretch w-full min-w-0">{t2}{t3}</div></div></div></li>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(rule, ruleIndex) {
  return <ReadOnlyRule key={rule} rule={rule} ruleIndex={ruleIndex} />;
}
function _temp2($) {
  return $.rulesNode.rule.ifLabel;
}
function _temp3($_0) {
  return $_0.rulesNode.rule.orLabel;
}